// extracted by mini-css-extract-plugin
module.exports = {"navLinks":"nav-module--navLinks--2iDMw","open":"nav-module--open--3WQ9J","icon":"nav-module--icon--3X-6d","navBar":"nav-module--navBar--2wCUV"};